// :cow: Cosmose CONFIDENTIAL :iso:
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

marker('OWN');
marker('COMPETITORS');

export enum GroupTypes {
  OWN = 'OWN',
  COMPETITORS = 'COMPETITORS',
}


